export const anime_genres = [
  { name: "Action", selected: false, id: "1" },
  { name: "Adventure", selected: false, id: "2" },
  { name: "Cars", selected: false, id: "3" },
  { name: "Comedy", selected: false, id: "4" },
  { name: "Dementia", selected: false, id: "5" },
  { name: "Demons", selected: false, id: "6" },
  { name: "Mystery", selected: false, id: "7" },
  { name: "Drama", selected: false, id: "8" },
  { name: "Ecchi", selected: false, id: "9" },
  { name: "Fantasy", selected: false, id: "10" },
  { name: "Game", selected: false, id: "11" },
  { name: "Historical", selected: false, id: "13" },
  { name: "Horror", selected: false, id: "14" },
  { name: "Kids", selected: false, id: "15" },
  { name: "Magic", selected: false, id: "16" },
  { name: "Martial Arts", selected: false, id: "17" },
  { name: "Mecha", selected: false, id: "18" },
  { name: "Music", selected: false, id: "19" },
  { name: "Parody", selected: false, id: "20" },
  { name: "Samurai", selected: false, id: "21" },
  { name: "Romance", selected: false, id: "22" },
  { name: "School", selected: false, id: "23" },
  { name: "Sci Fi", selected: false, id: "24" },
  { name: "Shoujo", selected: false, id: "25" },
  { name: "Shoujo Ai", selected: false, id: "26" },
  { name: "Shounen", selected: false, id: "27" },
  { name: "Shounen Ai", selected: false, id: "28" },
  { name: "Space", selected: false, id: "29" },
  { name: "Sports", selected: false, id: "30" },
  { name: "Super Powers", selected: false, id: "31" },
  { name: "Vampire", selected: false, id: "32" },
  { name: "Yaoi", selected: false, id: "33" },
  { name: "Yuri", selected: false, id: "34" },
  { name: "Harem", selected: false, id: "35" },
  { name: "Slice of Life", selected: false, id: "36" },
  { name: "Supernatural", selected: false, id: "37" },
  { name: "Military", selected: false, id: "38" },
  { name: "Police", selected: false, id: "39" },
  { name: "Psychological", selected: false, id: "40" },
  { name: "Thriller", selected: false, id: "41" },
  { name: "Seinen", selected: false, id: "42" },
  { name: "Josei", selected: false, id: "43" },
];

export const manga_genres = [
  { name: "Action", selected: false, id: "1" },
  { name: "Adventure", selected: false, id: "2" },
  { name: "Cars", selected: false, id: "3" },
  { name: "Comedy", selected: false, id: "4" },
  { name: "Dementia", selected: false, id: "5" },
  { name: "Demons", selected: false, id: "6" },
  { name: "Mystery", selected: false, id: "7" },
  { name: "Drama", selected: false, id: "8" },
  { name: "Ecchi", selected: false, id: "9" },
  { name: "Fantasy", selected: false, id: "10" },
  { name: "Game", selected: false, id: "11" },
  { name: "Historical", selected: false, id: "13" },
  { name: "Horror", selected: false, id: "14" },
  { name: "Kids", selected: false, id: "15" },
  { name: "Magic", selected: false, id: "16" },
  { name: "Martial Arts", selected: false, id: "17" },
  { name: "Mecha", selected: false, id: "18" },
  { name: "Music", selected: false, id: "19" },
  { name: "Parody", selected: false, id: "20" },
  { name: "Samurai", selected: false, id: "21" },
  { name: "Romance", selected: false, id: "22" },
  { name: "School", selected: false, id: "23" },
  { name: "Sci Fi", selected: false, id: "24" },
  { name: "Shoujo", selected: false, id: "25" },
  { name: "Shoujo Ai", selected: false, id: "26" },
  { name: "Shounen", selected: false, id: "27" },
  { name: "Shounen Ai", selected: false, id: "28" },
  { name: "Space", selected: false, id: "29" },
  { name: "Sports", selected: false, id: "30" },
  { name: "Super Powers", selected: false, id: "31" },
  { name: "Vampire", selected: false, id: "32" },
  { name: "Yaoi", selected: false, id: "33" },
  { name: "Yuri", selected: false, id: "34" },
  { name: "Harem", selected: false, id: "35" },
  { name: "Slice of Life", selected: false, id: "36" },
  { name: "Supernatural", selected: false, id: "37" },
  { name: "Military", selected: false, id: "38" },
  { name: "Police", selected: false, id: "39" },
  { name: "Psychological", selected: false, id: "40" },
  { name: "Seinen", selected: false, id: "41" },
  { name: "Josei", selected: false, id: "42" },
  { name: "Doujinshi", selected: false, id: "43" },
  { name: "Gender Bender", selected: false, id: "44" },
  { name: "Thriller", selected: false, id: "45" },
];
